import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { CheckCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { NavLink as Link } from "react-router-dom";
import $ from "jquery";
import axios from "../../services/axios";
import CompletedInterviews from "./CompletedInterviews";
import ReactLoading from "react-loading";
import isConsultant from "../../services/isConsultant";
import { Card } from "antd";
//datatable
var dt = require("datatables.net");
require("datatables.net-bs4");
$.DataTable = dt;

function ClientDashboard() {
  const [interviewList, setInterviewList] = useState([]);
  const [interviewCompletedCount, setInterviewCompletedCount] = useState(0);
  const [interviewPendingCount, setInterviewPendingCount] = useState(0);
  const [interviewTodayCount, setTodayUpcomingCount] = useState(0);
  const [load, setLoad] = useState(false);

  function isToday(date) {
    const today = new Date();
    if (
      today.getFullYear() === date.getFullYear() &&
      today.getMonth() === date.getMonth() &&
      today.getDate() === date.getDate()
    ) {
      return true;
    }
  }

  function formatDate(d) {
    let date = new Date(d);
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return (d =
      dd + "/" + mm + "/" + yyyy + " " + hours + ":" + minutes + ":" + seconds);
  }
  // function isYesterday(date) {
  //   const today = new Date();
  //   if (
  //     today.getFullYear() > date.getFullYear() ||
  //     today.getMonth() > date.getMonth() ||
  //     today.getDate() > date.getDate()
  //   ) {
  //     return true;
  //   }
  // }
  function isYesterday(d) {
    console.log("split", d);
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const date = today.getDate();
    //Note: 00 is month i.e. January
    const dateSplit = d.split("-");
    console.log(dateSplit);
    const givenDate = new Date(dateSplit[0], dateSplit[1], dateSplit[2]); //Year, Month, Date
    const todayDate = new Date(year, month + 1, date); //Year, Month, Date
    if (givenDate < todayDate) {
      return true;
    }
  }

  useEffect(() => {
    //  setLoad(true);
    axios
      .get("/interviews/clientId/" + localStorage.getItem("user.id"), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        console.log("table data", res.data);
        const arrObj = res.data.filter((ele) => {
          return (
            isToday(
              new Date(dateConverter(ele.candidate.L4SchdulingOn, "i"))
            ) && ele.candidate.L4_Status === "Pending"
          );
        });
        console.log("today", arrObj);
        setInterviewList(arrObj);
        setTodayUpcomingCount(arrObj.length);
        const completedArr = res.data.filter((ele) => {
          return (
            ele.candidate.L4_Status === "Selected" ||
            ele.candidate.L4_Status === "Rejected"
          );
        });
        console.log("sssssssssssssssssssss", completedArr.length);
        setInterviewCompletedCount(completedArr.length);

        const pendingArr = res.data.filter((ele) => {
          return (
            (isYesterday(dateConverter(ele.candidate.L4SchdulingOn, "i")) &&
              (ele.candidate.L4_Status === "" ||
                ele.candidate.L4_Status === "On Hold")) ||
            ele.candidate.L4_Status === "On Hold"
          );
        });
        setInterviewPendingCount(pendingArr.length);
        console.log("ddddddddd", pendingArr);
        setTimeout(() => {
          $("#table-datatable").DataTable({
            // order: [[3, "desc"]],
            // columnDefs: [{ targets: 3, type: "date" }],
            stateSave: true,
            bDestroy: true,
            responsive: true,
          });
        }, 100);
        //  setLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  console.log("todays", interviewList[0]?._id);

  const dateConverter = (d, i) => {
    const date = d.split("T");
    let p = date[0].split(/\D/g);
    let t = date[1].split(".");
    if (i) {
      return [p[0], p[1], p[2]].join("-");
    } else {
      return [p[2], p[1], p[0]].join("-") + " " + t[0];
    }
  };
  return (
    <div>
    {!isConsultant() && <div className="client-dashboard">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <Dashboard>
        <div className="row">
          <div className="col-md-4 col-sm-12">
            <div className="card d-flex flex-row align-items-center justify-content-between p-3 rounded-0 dash-card shadow-sm m-1">
              <div className="card-data">
                <p className="m-0 heading">Today's Interviews</p>
                <h2>{interviewTodayCount}</h2>
              </div>
              <div className="mr-2">
                <i className="fa fa-file-text-o icon"></i>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-12">
            <div className="card p-3 d-flex flex-row align-items-center justify-content-between rounded-0 dash-card shadow-sm m-1">
              <div className="card-data">
                <p className="m-0 heading">Total Pending Interviews</p>
                <h2>{interviewPendingCount}</h2>
              </div>
              <div className="mr-2">
                <ClockCircleOutlined className="icon" />
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-12">
            <div className="card p-3 d-flex flex-row align-items-center justify-content-between rounded-0 dash-card shadow-sm m-1">
              <div className="card-data">
                <p className="m-0 heading">Completed Interviews</p>
                <h2>{interviewCompletedCount}</h2>
              </div>
              <div className="mr-2">
                <CheckCircleOutlined className="icon" />
              </div>
            </div>
          </div>
        </div>
        <div className="row my-lg-3 mt-1">
          <div className="col-12">
            <Card
              className="card rounded-0 shadow-sm m-1"
              title="Today's Interviews"
            >
              <div className="table-responsive">
                <table id="table-datatable" className="table bg-white">
                  <thead className="table-head">
                    <tr>
                      <td className="table-column-head">Name</td>
                      <td className="table-column-head">Mobile</td>
                      <td className="table-column-head">
                        Interview Date & Time
                      </td>
                      <td className="table-column-head">Email</td>
                      <td className="table-column-head">Applied For</td>
                      <td className="table-column-head">Interview type</td>
                      <td className="table-column-head">Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    {interviewList?.map((ele, k) => {
                      return (
                        <tr key={k}>
                          <td>{ele.candidate.name}</td>
                          <td>{ele.candidate.mobileNo}</td>
                          <td>{formatDate(ele.candidate.L4SchdulingOn)}</td>

                          <td>{ele.candidate.email}</td>
                          <td>Customer Care Executive</td>
                          <td>Client Round</td>
                          <td>
                            <Link
                              to={{
                                pathname: "./upcominginterviewdetail",
                                state: {
                                  processName:
                                    ele.candidate.recommendedProcess[0].name,
                                  id: ele.candidate._id,
                                  day: "Today",
                                  date: formatDate(ele.candidate.L4SchdulingOn),
                                },
                              }}
                            >
                              <button
                                onClick={() => {
                                  localStorage.setItem(
                                    "candidate.Id",
                                    ele.candidate._id
                                  );
                                }}
                                class="btn btn-sm btn-primary btn-table-control mx-1"
                              >
                                View
                              </button>
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Card>
          </div>
        </div>
        {/* <div className="row">
          <div className="col-md-6 col-sm-12">
            <div className="card d-flex flex-row align-items-center justify-content-between p-3 rounded-0 dash-card shadow-sm m-1">
              <div className="card-data">
                <p className="m-0 heading">Completed Interviews</p>
                <p>Pie chart with selected, rejected, cancel status</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="card p-3 d-flex flex-row align-items-center justify-content-between rounded-0 dash-card shadow-sm m-1">
              <div className="card-data">
                <p className="m-0 heading">Interview done by job opening</p>
                <p>Pie chart with Senior Executive team lead</p>
              </div>
            </div>
          </div>
        </div> */}
      </Dashboard>
    </div>}
    </div>
  );
}

export default ClientDashboard;
